// extracted by mini-css-extract-plugin
export default {"Notes__Input_edit":"styles_Notes__Input_edit__1KfwO","Notes__noteBy":"styles_Notes__noteBy__e3fCa"};